export const iconFontAwesomeArrowsRightLong = (
	<i className="fa-solid fa-right-long"></i>
);
